import React from "react";
import Navbar from "../components/Navbar";
import MARS from "../components/MARS";
import Footer from "../components/Footer";



var Mars = () => {
  return(
   <>

<Navbar/>

<MARS />
<Footer />
</>
)
}

export default Mars;
